import React, { useState } from "react";
import { toast } from "react-toastify";
import Search from "../../components/form/Search";
import Button from "../../components/form/Button";
import Table from "../../components/elements/table/Table";
import { setTitle } from "../../helpers/MetaTag";
import { handleFilterChange } from "../../helpers";
import DeleteModal from "../../components/common/DeleteModal";

import useFetch from "../../hooks/useFetch";
import { useDebounce } from "../../hooks/useDebounce";
import LimitSelect from "../../components/elements/LimitSelect";
import {
  bannerDelete,
  bannerList,
  bannerStatusChange,
} from "../../services/bannersService";
import useMutation from "../../hooks/useMutation";
import Switch from "../../components/form/Switch";
import Badge from "../../components/elements/Badge";
// import ManageBannerModal from "../../components/sections/admin/banner/modals/ManageBannerModal";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const Banners = () => {
  setTitle("MemoryDoodle Admin | baners");
  const [selectedItems, setSelectedItems] = useState([]);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });
  const navigate = useNavigate();

  const { data, error, isLoading, updateData, isFetching, refetch } = useFetch({
    dependencies: ["banners", filters, search],
    fetchFunction: async () => {
      const res = await bannerList({
        ...filters,
        ...(search && { keyword: search }),
      });
      return res?.docs;
    },
  });

  //   banner status change handler =================>
  const { mutate: statusChangeHandler, isPending: statusChangeInPending } =
    useMutation({
      mutationFn: async ({ id, status }) => {
        const res = await bannerStatusChange({
          ids: id,
          status,
        });
        return { res, payload: { id, status } };
      },
      onSuccess: ({ res, payload }) => {
        if (res?.status !== 200) {
          updateData((pre) => {
            pre.data = (pre?.data || []).map((elm) =>
              elm?._id === payload?.id
                ? { ...elm, status: payload?.status === 1 ? 2 : 1 }
                : elm
            );
            return { ...pre };
          });
        }
      },
      onError: (error) => {
        console.log(error);
      },
    });

  const tableHeadData = [
    {
      _id: 1,
      name: "Image",
      align: "left",
    },
    {
      _id: 2,
      name: "Page",
      align: "left",
    },
    {
      _id: 3,
      name: "Description",
      align: "left",
    },
    {
      _id: 4,
      name: "Content Title",
      align: "left",
    },
    {
      _id: 5,
      name: "Content Description",
      align: "left",
    },
    {
      _id: 6,
      name: "SEO Title",
      align: "left",
    },
    {
      _id: 7,
      name: "SEO Description",
      align: "left",
    },
    // {
    //   _id: 8,
    //   name: "Created date",
    //   align: "left",
    // },
    {
      _id: 9,
      name: "Action",
      align: "left",
    },
  ];

  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 1,
          type: "user",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.title || "-",
          image: item?.image?.url,
          isTooltip: false,
        },
        {
          _id: 2,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data:
            item?.bannerType.charAt(0).toUpperCase() +
              item?.bannerType.slice(1) || "-",
        },
        {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data:
            (
              <div
                className="line-clamp-2"
                dangerouslySetInnerHTML={{ __html: item?.description }}
              ></div>
            ) || "-",
        },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.contentTitle || "-",
        },
        {
          _id: 5,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <div
              className="line-clamp-2"
              dangerouslySetInnerHTML={{
                __html: item?.contentDescription || "-",
              }}
            />
          ),
        },
        {
          _id: 6,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.seoTitle || "-",
        },
        {
          _id: 7,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <div
              className="line-clamp-2"
              dangerouslySetInnerHTML={{ __html: item?.seoDescription || "-" }}
            />
          ),
        },
        // {
        //   _id: 8,
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data: dayjs(item?.createdAt).format("DD MMM, YYYY") || "-",
        // },
        {
          _id: 9,
          type: "action",
          align: "left",
          cellClass: "w-[5%]",
          actionData: [
            {
              _id: 9.1,
              name: "Edit",
              icon: "fa-regular fa-pen-to-square",
              onClick: () => {
                navigate(`/admin/banners/manage?pageId=${item?._id}`);
              },
              standout: false,
            },
            // {
            //   _id: 9.2,
            //   name: "Delete",
            //   icon: "fa-regular fa-trash-can",
            //   standout: true,
            //   onClick: () => {
            //     setDeleteModal({
            //       isOpen: true,
            //       data: item,
            //     });
            //   },
            // },
          ],
        },
      ],
    };
  });

  // add or edit banner =================>
  function bannerManageResponse(res) {
    if (res?.status === 200 || res?.status === 201) {
      if (res?.status === 201) {
        if (filters?.page === 1) {
          updateData((pre) => ({ ...pre, data: [res?.data, ...pre?.data] }));
          refetch();
        } else {
          setFilters((pre) => ({ ...pre, page: 1 }));
        }
      }
      if (res?.status === 200) {
        updateData((pre) => ({
          ...pre,
          data: pre?.data?.map((item) =>
            item?._id === res?.data?._id ? res?.data : item
          ),
        }));
      }
      setModalOpen({ isOpen: false, data: null });
    } else {
      toast.warning(res?.message);
    }
  }

  //   banner delete handler =================>
  const { mutate: deleteHandler, isPending: deletePending } = useMutation({
    mutationFn: async (payload) => {
      const res = await bannerDelete({
        ids: Array.isArray(payload) ? payload : [payload],
      });
      return { res, payload: Array.isArray(payload) ? payload : [payload] };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        updateData((pre) => {
          pre.data = (pre?.data || [])?.filter(
            (item) => !payload?.includes(item?._id)
          );
          return { ...pre };
        });
        if (data?.metadata?.totalDocs > filters?.limit) {
          refetch();
        }
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-8">
        <div className="font-bold text-center text-lg xl:text-3xl text-chestnut-rose">
          Banners Management
        </div>
        <div className="flex items-center gap-3">
          <div className="w-36">
            <LimitSelect
              value={filters?.limit}
              allValue={data?.metadata?.totalDocs}
              onChange={(val) => handleFilterChange("limit", val, setFilters)}
            />
          </div>
          <div className="w-72">
            <Search
              placeholder={"Search here"}
              search={(val) => {
                setKeyword(val);
                handleFilterChange("page", 0, setFilters);
              }}
            />
          </div>
          {/* <div className="relative">
            <Button
              buttonClasses={
                "!bg-transparent border border-transparent !h-10 hover:!bg-chestnut-rose/10 hover:!border-chestnut-rose/10"
              }
              buttonLabel={"Create New"}
              buttonLabelClasses={"font-medium !text-sm text-chestnut-rose"}
              buttonHasLink
              buttonLink={"/admin/banners/manage"}
            />
          </div> */}
        </div>
      </div>
      <Table
        tableHeadData={tableHeadData}
        tableData={tableData}
        isLoder={isLoading}
        pageCount={data?.metadata?.totalPages}
        currentPage={filters?.page}
        onPageChange={(val) => {
          handleFilterChange("page", val, setFilters);
          setSelectedItems([]);
        }}
        handleOrdering={(val) => {
          console.log(val);
        }}
        isFetching={isFetching}
        isOrderingDisabled={true}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        tableActionDropdownContainer={"!w-48"}
      />
      {/* <ManageBannerModal
        open={modalOpen?.isOpen}
        data={modalOpen?.data}
        close={() => setModalOpen({ isOpen: false, data: null })}
        getResponse={bannerManageResponse}
      /> */}
      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        deleteHandler={() => {
          deleteHandler(deleteModal?.data?._id);
        }}
      />
    </div>
  );
};

export default Banners;
